export const approvePending = {
    show: 'Autorización no identificado',
    columns: [
      {
        title: 'Cotización',
        name: 'value',
        type: 'string',
        class: 'left',
        value: (element: any) => element.value
      },
      {
        title: 'Pendiente/s',
        name: 'issue',
        type: 'string',
        class: 'left',
        value: (element: any) => element.issue
      }
    ]
  };
